import {getConfiguration} from '@nuskin/configuration-sdk';
import storage from "./storage.js";

/**
 *
 * StoreFrontSponsorStorageService
 *
 * @namespace StoreFrontSponsorStorageService
 */
"use strict";

let STORAGE_KEY = storage.metadata.STOREFRONT;

// ---------------------------------------------
//
//            Define public methods
//
// ---------------------------------------------
var publicMethods = {
    clearStoreFrontSponsor: function () {
        publicMethods.setStoreFrontSponsor(null);
    },
    getStoreFrontSponsor: function () {
        return storage.getItem(STORAGE_KEY);
    },
    setStoreFrontSponsor: function (sponsor) {
        if (sponsor == null || typeof (sponsor) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else {
            storage.setItem(STORAGE_KEY, sponsor);
        }
    },
    isStorefront: function () {
        let storefront = publicMethods.getStoreFrontSponsor();
        return storefront !== null && storefront !== undefined;
    },
    getDisplayName: async function ({source, userId, getAccountInfo} = {}) {
        let name;

        try {
            if (!source) {
                const {Storefront: storefrontCfg} = await getConfiguration(['Storefront']);
                source = storefrontCfg.userDisplayNameSrc || '';
            }

            switch (source) {
                case 'accountservice':
                {
                    if (userId) {
                        const accountInfo = await getAccountInfo(userId);
                        if (accountInfo) name = accountInfo.preferredName;
                    }

                    break;
                }
            }
        } catch (ex) {
            console.error(ex);
        }

        if (!name) {
            const sponsor = publicMethods.getStoreFrontSponsor();
            if (sponsor) name = sponsor.displayName;
        }

        return name;
    }
};

export default publicMethods;
